export default __webpack_public_path__ + "static/media/usersCycle.2bc72835.svg";